import { ClusteredMarkerLayer } from '../Layers/ClusteredMarkersLayer';
import { FilterLayer } from '../Layers/FilterLayer';
import type { FilterLayerOptions } from '../Layers/Layers.types';

export const bikeFilterCurrent = function (layers: ClusteredMarkerLayer[], options?: FilterLayerOptions): FilterLayer {
    const defaultOptions: FilterLayerOptions = {
        filterFn: (filteredMarkers, filteredFeatures) => {
            return filteredFeatures.filter((feature) => {
                const props = feature.properties;
                return filteredMarkers.includes(feature) || !props.isFuture;
            });
        },
    };

    return new FilterLayer('bike-filter-current', layers, { ...defaultOptions, ...options });
};
